import { useEffect, useState } from "react";

export const App = ()=>{

  const [buttonBgColor,setButtonBgColor] = useState('#e63f94');
  const [buttonColor,setButtonColor] = useState('white');
  const [buttonBorderColor,setButtonBorderColor] = useState('');
  const [pageBgColor,setPageBgroundColor] = useState();
  const [buttonText,setButtonText] = useState('PLAY NOW');

  const [show,setShow] = useState(false);

  const onClick = ()=>{
    const url = new URL(window.location.href);
  
    const target =decodeURIComponent(url.searchParams.get('target'));

  

    if(!target || target==="null") return;
    
    window.open(target);
  };



  useEffect(()=>{

    const url = new URL(window.location.href);

    const cc = c => {
      if(c.startsWith('*')){
        c= c.replace('*','#');
      }
  
      return c;
    };

    const setStyle = ({key,setter})=>{  
      const val =url.searchParams.get(key);


      if(val){
        if(key.indexOf('-color')>0){
          setter(cc(val));
        }else{
          setter(val);
        }
        
      }

    };
    
    const styles = [
      {key:'button-bg-color',setter:setButtonBgColor},
      {key:'button-color',setter:setButtonColor},
      {key:'page-bg-color',setter:setPageBgroundColor},
      {key:'button-border-color',setter:setButtonBorderColor},
      {key:'button-text',setter:setButtonText}
      
    ];
        
    styles.forEach(style=>setStyle(style));

    setShow(true);

  },[]);

  

  const buttonStyle = {
    backgroundColor:buttonBgColor,
    borderColor:buttonBorderColor,
    color: buttonColor
  };

  const pageStyle = pageBgColor ? {backgroundColor:pageBgColor} : {};
  
  return show && <div className="container" style={pageStyle}>
    <button className="button" style={buttonStyle} onClick={onClick}>{buttonText}</button>
  </div>
};